import { useEffect, useRef } from 'react';
import './Overview.css';

const facts = [
    { icon: '🏛️', label: 'Birth', value: '1137 CE, Tikrit, Iraq' },
    { icon: '⚔️', label: 'Dynasty', value: 'Ayyubid Dynasty — Founder' },
    { icon: '🌍', label: 'Ruled', value: 'Egypt, Syria, Yemen & Parts of North Africa' },
    { icon: '🕌', label: 'Legacy', value: 'Liberated Jerusalem on Oct 2, 1187 CE' },
];

const Overview = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.reveal, .reveal-left, .reveal-right')
                            .forEach((el) => el.classList.add('revealed'));
                    }
                });
            },
            { threshold: 0.15 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="overview" className="overview" ref={sectionRef}>
            <div className="overview__bg-decoration"></div>
            <div className="section-wrapper">
                <div className="overview__grid">
                    <div className="overview__bio reveal-left">
                        <span className="section-tag">Historical Overview</span>
                        <h2 className="section-title">
                            The <span className="gold-text">Lion</span> of Islam
                        </h2>
                        <div className="divider"></div>
                        <p className="overview__text">
                            Salah ad-Din Yusuf ibn Ayyub, known in the Western world as Saladin, was the
                            first sultan of Egypt and Syria and the founder of the Ayyubid dynasty. Born
                            in 1137 in Tikrit, he rose from a Kurdish military family to become one of
                            history's greatest military commanders.
                        </p>
                        <p className="overview__text">
                            Renowned not only for his military prowess but also for his personal chivalry
                            and magnanimity, Saladin became a legendary figure in both the Muslim and
                            Christian worlds. Even his adversaries — including King Richard I of England
                            — praised his nobility and honor.
                        </p>
                        <p className="overview__text">
                            His recapture of Jerusalem on October 2, 1187 CE, following the decisive
                            <em> Battle of Hattin</em>, is considered one of the most significant events
                            of the medieval era. Unlike the brutal Crusader conquest of 1099, Saladin
                            spared the Christian population and allowed safe passage.
                        </p>
                        <div className="overview__quote-snippet">
                            <span className="overview__quote-mark">"</span>
                            <p>I warn you against shedding blood, indulging in it and making a habit of it, for blood never sleeps.</p>
                        </div>
                    </div>


                    <div className="overview__facts reveal-right">
                        <div className="overview__facts-card">
                            <h3 className="overview__facts-title">Quick Facts</h3>
                            <div className="overview__facts-list">
                                {facts.map((fact, index) => (
                                    <div key={index} className={`overview__fact delay-${index + 1} reveal`}>
                                        <span className="overview__fact-icon">{fact.icon}</span>
                                        <div className="overview__fact-content">
                                            <span className="overview__fact-label">{fact.label}</span>
                                            <span className="overview__fact-value">{fact.value}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="overview__badge">
                                <div className="overview__badge-ring"></div>
                                <div className="overview__badge-inner">
                                    <span className="overview__badge-icon">☽</span>
                                    <span className="overview__badge-year">1137–1193</span>
                                    <span className="overview__badge-label">CE</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Overview;
